export class ExportColumns {
    type: string;
    columns: string[];
}